import { Popover, Transition } from "@headlessui/react";
import Input from "shared/Input/Input";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

interface SearchDropdownProps {
  isDark?: boolean;
}

const SearchDropdown: React.FC<SearchDropdownProps> = ({ isDark = false }) => {
  const inputRef = React.createRef<HTMLInputElement>();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchQuery === "") {
      setSearchParams({});
      navigate(`/`);
      return;
    }

    if (searchQuery && searchQuery.length > 0) {
      navigate(`/products?search=${searchQuery}`);
    }
  }, [searchQuery, navigate, setSearchParams]);

  return (
    <Popover className="relative">
      {({ open }) => {
        if (open) {
          setTimeout(() => {
            inputRef.current?.focus();
          }, 100);
        }

        return (
          <>
            <Popover.Button
              className={`text-xl w-10 h-10 rounded-full focus:outline-none flex items-center justify-center transition-colors ${
                isDark
                  ? "text-white/80 hover:bg-white/10"
                  : "text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800"
              }`}
            >
              <i className="las la-search"></i>
            </Popover.Button>

            <Transition
              show={open}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel
                static
                className="absolute right-0 z-10 w-screen max-w-sm mt-3"
              >
                <form onSubmit={(e) => e.preventDefault()}>
                  <Input
                    ref={inputRef}
                    type="search"
                    placeholder="Search products..."
                    value={searchQuery || ""}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <input type="submit" hidden value="" />
                </form>
              </Popover.Panel>
            </Transition>
          </>
        );
      }}
    </Popover>
  );
};

export default SearchDropdown;
